<template>
  <div class="block page7">
    <div class="content f-r f-c a-c j-c">
      <div class="title">
        {{ moduleData["3_7_1_1"] }}
      </div>
      <div class="sub-title">
        {{ moduleData["3_7_1_1_en"] }}
      </div>
    </div>
    <PageTips />
  </div>
</template>

<script setup>
import PageTips from "./components/PageTips";

defineProps({
  moduleData: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>

<style lang="less">
.page7 {
  background: #333333;
  position: relative;
  .content {
    width: 100%;
    height: 100%;
    .title {
      width: 100%;
      text-align: center;
      height: 154px;
      font-size: 110px;

      font-weight: bold;
      color: #ffffff;
      line-height: 154px;
    }
    .sub-title {
      width: 100%;
      text-align: center;
      font-size: 86px;

      font-weight: bold;
      color: #ffffff;
      line-height: 86px;
    }
  }
}
</style>
